import React, { useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    numberFormatInt,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTime,
    getTodayDateISO,
    getBranchId
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

import { getAllFranchisee } from "../../../Helpers/apiCalls/franchiseeApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { searchDailyUsage } from './../../../Helpers/apiCalls/Reports/DailyUsageApi';
import { getAllProducts } from './../../../Helpers/apiCalls/Manage/Products';
import { getSalesPerProduct, getSalesPerProductPotato } from './../../../Helpers/apiCalls/Reports/DailyOrdersApi';
import { getAllBranchesPotato } from './../../../Helpers/apiCalls/PotatoCorner/Manage/Branches';
import { getAllProductsPotato } from './../../../Helpers/apiCalls/PotatoCorner/Manage/Products';
import Footer from "../../../Components/Footer/Footer";
import { useEffect } from "react";
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination";

export default function SalesPerProduct() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();

    const [inactive, setInactive] = useState(true);
    const today = Moment().format("MM/DD/YYYY");
    const [filterConfig, setFilterConfig] = useState({
        date_from: new Date(),
        date_to: new Date(),
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
        page: 1
    })
    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [allData, setAllData] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalSales, setTotalSales] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [selectedRow, setSelectedRow] = useState([]);
    const [items, setItems] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
            ...prev,
            page: page,
        }));
    };
    
    const xlsxHeaders = [
        "PRODUCT NAME",
        "SIZE",
        "QUANTITY",
        "SUBTOTAL",
        "DISCOUNT",
        "TOTAL SALES",
    ]

    const excelHeaders = [
        { label: "Product", key: "product" },
        { label: "Size", key: "size" },
        { label: "Price", key: "store_price" },
        { label: "Quantity", key: "qty" },
        { label: "Subtotal", key: "subtotal" },
        { label: "Discount", key: "discount" },
        { label: "Total Sales", key: "total_sales" },
    ];

    async function fetchBranches() {
        setBranches([])

        const response = await getAllBranches();
        if (response.error) {
        } else {
            var allBranches = response.data.data.data
            .filter((data) => { return (data.is_franchise !== "3" && data.is_franchise !== "1")})
            .map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = allBranches.filter((data) => {
                return data.value === getBranchId()
                })
                setBranches(filteredBranch);
            } else {
                setBranches([{label: "All Branches", value:""}, ...allBranches]);
            }
        }
    }
    
    async function fetchAllProducts() {
        setItems([])
        const response = await getAllProducts();

        if (response.data) {
            var data = response.data.data.data.map((item) => {
                var info = item;
                info.label = item.name
                info.value = item.id
                return info;
            });
            setItems([{label: "All Products", value:""}, ...data]);
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setAllData([])
        setExcelData([])
        setTotalQuantity(0);
        setTotalSales(0);
        setTotalDiscount(0);
        setTotalItems(0)

        const response = await getSalesPerProduct(filterConfig);
        

        if (response.data) {
            var allProducts = response.data.data.sales_per_product.map((bill) => {
                var items = ""
                var info = bill;
                info.store_price = numberFormat(bill.store_price)
                info.subtotal = numberFormat(bill.subtotal)
                info.qty = numberFormat(bill.qty)
                info.total_sales = numberFormat(bill.total_sales)
                info.order_date = Moment(bill.added_on).format("MM-DD-YYYY")
                return info;
            });
            var allSinkers = response.data.data.sales_per_sinker.map((bill) => {
                var items = ""
                var info = bill;
                info.product = bill.product + " (Sinker)"
                info.store_price = numberFormat(bill.store_price)
                info.subtotal = numberFormat(bill.subtotal)
                info.qty = numberFormat(bill.qty)
                info.total_sales = numberFormat(bill.total_sales)
                info.order_date = Moment(bill.added_on).format("MM-DD-YYYY")
                return info;
            });
            setAllData(allProducts.concat(allSinkers))

            var array = allProducts.concat(allSinkers)
            var excel = array.map((bill) => {
                var info = {};
                info.product = bill.product
                info.size = bill.size
                info.qty = bill.qty
                info.subtotal = bill.subtotal
                info.discount = bill.discount
                info.total_sales = bill.total_sales
                return info;
            });
            setExcelData(excel)

            var total_qty = response.data.summary? response.data.summary.total_qty : "0";
            var total_sales = response.data.summary? response.data.summary.total_sales : "0";
            var total_discount = response.data.summary? response.data.summary.total_discount : "0";
            setTotalQuantity(total_qty);
            setTotalSales(total_sales);
            setTotalDiscount(total_discount);
            setTotalItems(response.data.size);
        }
        setShowLoader(false);
    }
    
    const handleTabSelect = (tabKey) => {
        setFilterConfig((prev) => {
            return {
                ...prev,
                tab: tabKey,
                product_id: "",
                branch_id: "",
                date_from: "",
                date_to: "",
            };
        });
    };

    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
        XLSX.writeFile(workbook, "SalesPerProduct.xlsx", { compression: true });
    }

    useEffect(() => {
        fetchBranches();
        fetchAllProducts()
    }, [filterConfig]);

    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"STORE REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}

                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> SALES PER PRODUCT REPORT </h1>
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Product"
                            styles={{
                                control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                borderRadius: "7px",
                                border: "0px",
                                minHeight: "20px",
                                maxHeight: "35px",
                                }),
                                input: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: state.isSelected? "white": "white",
                                    
                                }),
                                dropdownIndicator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                placeholder: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                
                            }}
                            // value={branch}
                            options={items}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "product_id": e.value };
                                });}}
                        />
                        </Col>
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={{
                                control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                borderRadius: "7px",
                                border: "0px",
                                minHeight: "20px",
                                maxHeight: "35px",
                                }),
                                input: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: state.isSelected? "white": "white",
                                    
                                }),
                                dropdownIndicator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                placeholder: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                
                            }}
                            options={branches}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "branch_id": e.value };
                                });}}
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className=" PO-filters d-flex justify-content-center">
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Quantity: {numberFormat(totalQuantity)}
                        </span>
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Sales: {numberFormat(totalSales)}
                        </span>
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Discount: {numberFormat(totalDiscount)}
                        </span>
                    </div>

                    <div className="below">
                        {/* table */}
                        <TableWithDynamicPagination
                            tableHeaders={[
                                "PRODUCT NAME",
                                // "SIZE",
                                "QUANTITY",
                                "SUBTOTAL",
                                "DISCOUNT",
                                "TOTAL SALES",
                            ]}
                            headerSelector={[
                                "product",
                                // "size",
                                "qty",
                                "subtotal",
                                "discount",
                                "total_sales",
                            ]}
                            tableData={allData}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
                <div className="mb-3" />
                <br /><br />
                <Row>
                    <Col lg={10} className="mt-3 mt-lg-0"></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                    </Col>
                </Row>
                <div className="mb-3" />
                <br /><br />
            </div>
            <Footer/>
        </div>
    );
}
